var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6025 8.92533C11.9525 8.92533 11.4256 9.45225 11.4256 10.1022C11.4256 10.7522 11.9525 11.2792 12.6025 11.2792C13.2525 11.2792 13.7794 10.7522 13.7794 10.1022C13.7794 9.45225 13.2525 8.92533 12.6025 8.92533ZM10.2922 10.1022C10.2922 8.82633 11.3266 7.79199 12.6025 7.79199C13.8784 7.79199 14.9127 8.82633 14.9127 10.1022C14.9127 11.3782 13.8784 12.4125 12.6025 12.4125C11.3266 12.4125 10.2922 11.3782 10.2922 10.1022Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6029 5.13333C15.3475 5.13333 17.5722 7.35813 17.5722 10.1026C17.5722 11.067 17.2496 12.1736 16.6944 13.3415C16.144 14.4991 15.3992 15.6465 14.6358 16.6731C14.2629 17.1745 13.8895 17.642 13.538 18.0623L14.2772 18.9441C16.1393 16.744 18.7055 13.1578 18.7055 10.1026C18.7055 6.73223 15.9735 4 12.6029 4C9.23239 4 6.50037 6.73223 6.50037 10.1026C6.50037 13.8187 10.0349 18.3202 11.6254 20.1577C12.0871 20.6911 12.385 21 12.385 21C12.385 21 12.6937 20.7019 13.1746 20.1858C12.3279 19.2362 12.4376 19.3649 12.3279 19.2362C11.7937 18.6097 11.083 17.7276 10.3745 16.7043C8.91341 14.5938 7.6337 12.1224 7.6337 10.1026C7.6337 7.35813 9.85834 5.13333 12.6029 5.13333Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationWhite);
export default __webpack_public_path__ + "static/media/location-white.60330c5c51822dacc1338f32a44296cc.svg";
export { ForwardRef as ReactComponent };